// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

export interface GetConversionTypeSelectResponse {
    conversionTypes: ConversionType[];
}
interface ConversionType {
    title: string;
}
class ConversionTypeApi extends TenantBaseApi {
    async index(request): Promise<GetConversionTypeSelectResponse> {
        return await this.get<GetConversionTypeSelectResponse, void>("/conversion-types", {
            params: request,
        });
    }
}

export const conversionTypeApi = new ConversionTypeApi();
